<template>
  <div v-if="data && dataAnggota" class="animated fadeIn pdf">
    <div class="print-button">
      <b-button type="button" variant="primary" @click="printPdf" class="btn my-3">Print PDF</b-button>
    </div>
    <!-- Dipreview  -->
    <div class="pdf-content-preview" style="width: 800px;font-weight: 800;">
      <div class="relative">
        <div class="absolute cabang">
          <p>{{ data.bannerName || "-" }}</p>
        </div>
        <div class="absolute no-telp">
          <p>{{ data.noTelpCabang || "-" }}</p>
        </div>
        <div class="absolute no-sbg">
          <h6>{{ data.noFaktur || "-" }}</h6>
        </div>
        <div class="absolute qr-code">
          <qrcode-vue :value="data.noFakturBarcode" size="80" level="H" />
        </div>
        <div class="absolute tgl-transaksi">
          <p>{{ data.tanggalTransaksi || "-" }}</p>
        </div>
        <div class="absolute tgl-jatuh-tempo">
          <p>{{ data.tanggalJatuhTempo || "-" }}</p>
        </div>
        <div class="absolute data-diri">
          <p>{{ data.nasabah1 || "-" }}</p>
          <p>{{ data.nasabah2 || "-" }}</p>
          <div class="no-anggota">
            <p>{{ dataAnggota.anggota.noIdentitas || "-" }}</p>
          </div>
          <div class="no-telp">
            <p>{{ data.nasabah3 || "-" }}</p>
          </div>
          <div class="alamat">
            <p>
              {{ data.nasabah4 || "-" }}
            </p>
          </div>
        </div>
        <div class="absolute keterangan">
          <p>
            {{ data.barang || "-" }}
          </p>
        </div>
        <div class="absolute pinjaman">
          <p>{{ data.taksiran || "-" }}</p>
          <p>{{ data.nilaiPinjaman || "-" }}</p>
        </div>
        <div class="absolute tanggal">
           <p>{{ data.kotaCabang || "-" }},
              {{ data.tanggal || "-" }}
              </p>
        </div>
        <div class="absolute nama">
          <p>{{ data.nasabah2 || "-" }}</p>
        </div>
        <div class="absolute bilangan">
          <p>{{ convertTerbilangToInt(data.nilaiPinjaman) | terbilang }}</p>
        </div>
        <div class="absolute qr-code-2">
          <h6>{{ data.noFaktur || "-" }}</h6>
          <qrcode-vue :value="data.noFakturBarcode" size="80" level="H" v-if="data.noFakturBarcode" />
          <div v-else>Not Found</div>
        </div>
        <div class="absolute kode">
          <h6>{{ data.kantorCabang || "-" }}</h6>
        </div>
        <div class="absolute no">
          <h3>{{ numberOfDate || "-" }}</h3>
        </div>
        <div class="absolute flex no-2">
          <span>No : </span>
          <h6 class="ml-1">{{ data.noFaktur || "-" }}</h6>
        </div>
        <div class="absolute data-diri-2">
          <p>{{ data.tanggalTransaksi || "-" }}</p>
          <p>{{ data.tanggalJatuhTempo || "-" }}</p>
          <p :class="data.jenisPinjaman == 'BPKB' ? 'no-anggota' : 'no-anggota-non-bpkb'">
          {{ data.nasabah1 || "-" }}</p>
          <p>{{ data.nasabah2 || "-" }}</p>
          <p class="no-ktp">{{ dataAnggota.anggota.noIdentitas || "-" }}</p>
          <p class="no-telp">{{ data.nasabah3 || "-" }}</p>
          <div class="alamat">
            <p>
              {{ data.nasabah4 || "-" }}
            </p>
          </div>
        </div>
        <div class="absolute keterangan-2">
          <p>
            {{ data.barang || "-" }}
          </p>
        </div>
        <div class="absolute uang">
          <p>{{ data.taksiran || "-" }}</p>
          <p>{{ data.nilaiPinjaman || "-" }}</p>
        </div>
        <div class="absolute tgl">
          <p>{{ data.kotaCabang || "-" }},
          {{ data.tanggal || "-" }}
          </p>
        </div>
        <div class="absolute nasabah">
          <p>{{ data.nasabah2 || "-" }}</p>
        </div>
        <div class="absolute" style="top: 825px; right: 10px;">
          <div
              style="
                width: 210px;
                height: 260px;
                overflow: hidden;
                position: relative;
              "
            >
              <img
                v-if="data.fotoBase64"
                :src="data.fotoBase64"
                alt="foto"
                style="
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                margin: auto;
                object-fit: contain;
                "
              />
          <img v-else width="100" height="150" src="/img/blank-ktp.png" alt="no-ktp" />
        </div>
        </div>
      </div>

      <img src="/img/sbg-33.webp" alt="sbg" />
    </div>
    <!-- Diprint -->
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
      :paginate-elements-by-height="1400" :pdf-quality="2" :manual-pagination="false" pdf-format="a4"
      pdf-orientation="portrait" @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
      ref="html2Pdf" :html-to-pdf-options="htmlToPdfOptions">
      <section slot="pdf-content">
        <div style="height:1117px;margin-top:-7px;font-weight: 800;">
          <div class="relative">
            <div class="absolute cabang">
              <p>{{ data.bannerName || "-" }}</p>
            </div>
            <div class="absolute no-telp">
              <p>{{ data.noTelpCabang || "-" }}</p>
            </div>
            <div class="absolute no-sbg">
              <h6>{{ data.noFaktur || "-" }}</h6>
            </div>
            <div class="absolute qr-code">
              <qrcode-vue v-if="data.noFakturBarcode" :value="data.noFakturBarcode" size="80" level="H" />
              <div v-else>{{ data.noFakturBarcode }}</div>
            </div>
            <div class="absolute tgl-transaksi">
              <p>{{ data.tanggalTransaksi || "-" }}</p>
            </div>
            <div class="absolute tgl-jatuh-tempo">
              <p>{{ data.tanggalJatuhTempo || "-" }}</p>
            </div>
            <div class="absolute data-diri">
              <p>{{ data.nasabah1 || "-" }}</p>
              <p>{{ data.nasabah2 || "-" }}</p>
              <div class="no-anggota">
                <p>{{ dataAnggota.anggota.noIdentitas || "-" }}</p>
              </div>
              <div class="no-telp">
                <p>{{ data.nasabah3 || "-" }}</p>
              </div>
              <div class="alamat">
                <p>
                  {{ data.nasabah4 || "-" }}
                </p>
              </div>
            </div>
            <div class="absolute keterangan">
              <p>
                {{ data.barang || "-" }}
              </p>
            </div>
            <div class="absolute pinjaman">
              <p>{{ data.taksiran || "-" }}</p>
              <p class="nilai-pinjaman">{{ data.nilaiPinjaman || "-" }}</p>
            </div>
            <div class="absolute tanggal">
              <p>{{ data.kotaCabang || "-" }},
              {{ data.tanggal || "-" }}
              </p>
            </div>
            <div class="absolute nama">
              <p>{{ data.nasabah2 || "-" }}</p>
            </div>
            <div class="absolute bilangan">
              <p>{{ convertTerbilangToInt(data.nilaiPinjaman) | terbilang }}</p>
            </div>
            <div class="absolute qr-code-2">
              <h6>{{ data.noFaktur || "-" }}</h6>
              <qrcode-vue :value="data.noFakturBarcode" size="80" level="H" />
            </div>
            <div class="absolute kode">
              <h6>{{ data.kantorCabang || "-" }}</h6>
            </div>
            <div class="absolute no">
              <h3>{{ numberOfDate || "-" }}</h3>
            </div>
            <div class="absolute flex no-2">
              <span>No : </span>
              <h6 class="ml-1">{{ data.noFaktur || "-" }}</h6>
            </div>
            <div class="absolute data-diri-2">
              <p>{{ data.tanggalTransaksi || "-" }}</p>
              <p>{{ data.tanggalJatuhTempo || "-" }}</p>
              <p :class="data.jenisPinjaman == 'BPKB' ? 'no-anggota' : 'no-anggota-non-bpkb'">{{ data.nasabah1 || "-" }}</p>
              <p>{{ data.nasabah2 || "-" }}</p>
              <p class="no-ktp">{{ dataAnggota.anggota.noIdentitas || "-" }}</p>
              <p class="no-telp">{{ data.nasabah3 || "-" }}</p>
              <div class="alamat">
                <p>
                  {{ data.nasabah4 || "-" }}
                </p>
              </div>
            </div>
            <div class="absolute keterangan-2">
              <p>
                {{ data.barang || "-" }}
              </p>
            </div>
            <div class="absolute uang">
              <p>{{ data.taksiran || "-" }}</p>
              <p class="uang-pinjaman">{{ data.nilaiPinjaman || "-" }}</p>
            </div>
            <div class="absolute tgl">
              <p>{{ data.kotaCabang || "-" }},
              {{ data.tanggal || "-" }}
              </p>
            </div>
            <div class="absolute nasabah">
              <p>{{ data.nasabah2 || "-" }}</p>
            </div>
          <div class="absolute" style="top: 850px; right: 10px;">
            <div
              style="
                width: 210px;
                height: 230px;
                overflow: hidden;
                position: relative;
              "
            >
              <img
                v-if="data.fotoBase64"
                :src="data.fotoBase64"
                alt="foto"
                style="
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                margin: auto;
                object-fit: contain;
                "
              />
              <img v-else width="100" height="150" src="/img/blank-ktp.png" alt="no-ktp" />
            </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {};
  },
  props: ["data", "data-anggota"],
  methods: {
    printPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    convertTerbilangToInt(val) {
      const nilai = parseInt(val.split(".").join("")) || "-";

      return nilai;
    },
  },
  filters: {
    terbilang: function (value) {
      function terbilang(a) {
        var bilangan = [
          "",
          "Satu",
          "Dua",
          "Tiga",
          "Empat",
          "Lima",
          "Enam",
          "Tujuh",
          "Delapan",
          "Sembilan",
          "Sepuluh",
          "Sebelas",
        ];

        // 1 - 11
        if (a < 12) {
          var kalimat = bilangan[a];
        }
        // 12 - 19
        else if (a < 20) {
          var kalimat = bilangan[a - 10] + " Belas";
        }
        // 20 - 99
        else if (a < 100) {
          var utama = a / 10;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 10;
          var kalimat = bilangan[depan] + " Puluh " + bilangan[belakang];
        }
        // 100 - 199
        else if (a < 200) {
          var kalimat = "Seratus " + terbilang(a - 100);
        }
        // 200 - 999
        else if (a < 1000) {
          var utama = a / 100;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 100;
          var kalimat = bilangan[depan] + " Ratus " + terbilang(belakang);
        }
        // 1,000 - 1,999
        else if (a < 2000) {
          var kalimat = "Seribu " + terbilang(a - 1000);
        }
        // 2,000 - 9,999
        else if (a < 10000) {
          var utama = a / 1000;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 1000;
          var kalimat = bilangan[depan] + " Ribu " + terbilang(belakang);
        }
        // 10,000 - 99,999
        else if (a < 100000) {
          var utama = a / 100;
          var depan = parseInt(String(utama).substr(0, 2));
          var belakang = a % 1000;
          var kalimat = terbilang(depan) + " Ribu " + terbilang(belakang);
        }
        // 100,000 - 999,999
        else if (a < 1000000) {
          var utama = a / 1000;
          var depan = parseInt(String(utama).substr(0, 3));
          var belakang = a % 1000;
          var kalimat = terbilang(depan) + " Ribu " + terbilang(belakang);
        }
        // 1,000,000 -  99,999,999
        else if (a < 100000000) {
          var utama = a / 1000000;
          var depan = parseInt(String(utama).substr(0, 4));
          var belakang = a % 1000000;
          var kalimat = terbilang(depan) + " Juta " + terbilang(belakang);
        } else if (a < 1000000000) {
          var utama = a / 1000000;
          var depan = parseInt(String(utama).substr(0, 4));
          var belakang = a % 1000000;
          var kalimat = terbilang(depan) + " Juta " + terbilang(belakang);
        } else if (a < 10000000000) {
          var utama = a / 1000000000;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 1000000000;
          var kalimat = terbilang(depan) + " Milyar " + terbilang(belakang);
        } else if (a < 100000000000) {
          var utama = a / 1000000000;
          var depan = parseInt(String(utama).substr(0, 2));
          var belakang = a % 1000000000;
          var kalimat = terbilang(depan) + " Milyar " + terbilang(belakang);
        } else if (a < 1000000000000) {
          var utama = a / 1000000000;
          var depan = parseInt(String(utama).substr(0, 3));
          var belakang = a % 1000000000;
          var kalimat = terbilang(depan) + " Milyar " + terbilang(belakang);
        } else if (a < 10000000000000) {
          var utama = a / 10000000000;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 10000000000;
          var kalimat = terbilang(depan) + " Triliun " + terbilang(belakang);
        } else if (a < 100000000000000) {
          var utama = a / 1000000000000;
          var depan = parseInt(String(utama).substr(0, 2));
          var belakang = a % 1000000000000;
          var kalimat = terbilang(depan) + " Triliun " + terbilang(belakang);
        } else if (a < 1000000000000000) {
          var utama = a / 1000000000000;
          var depan = parseInt(String(utama).substr(0, 3));
          var belakang = a % 1000000000000;
          var kalimat = terbilang(depan) + " Triliun " + terbilang(belakang);
        } else if (a < 10000000000000000) {
          var utama = a / 1000000000000000;
          var depan = parseInt(String(utama).substr(0, 1));
          var belakang = a % 1000000000000000;
          var kalimat = terbilang(depan) + " Kuadriliun " + terbilang(belakang);
        }

        var pisah = kalimat.split(" ");
        var full = [];
        for (var i = 0; i < pisah.length; i++) {
          if (pisah[i] != "") {
            full.push(pisah[i]);
          }
        }
        return full.join(" ");
      }
      return terbilang(value) + " Rupiah";
    },
  },
  computed: {
    numberOfDate() {
      return this.data.tanggalTransaksi.split(" ")[0] || "-";
    },
    htmlToPdfOptions() {
      return {
        html2canvas: {
          taintTest: true,
          useCORS: true,
        },
      };
    },
  },
  components: {
    VueHtml2pdf,
    QrcodeVue,
  },
};
</script>

<style scoped>
.paper {
  background-color: white;
  padding: 4rem;
  width: 100%;
}

.pdf {
  width: 100%;
  height: 100%;
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.print-button {
  display: flex;
  justify-content: flex-end;
}

table {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #1e72bd;
}

tr,
td {
  border: 1px solid #1e72bd;
  padding: 5px;
}

img {
  width: 100%;
}

p {
  font-size: 11px;
}

ol li {
  font-size: 11px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.cabang {
  top: 48px;
  left: 290px;
  width: 100px;
  word-wrap: break-word;
}

.pdf-content-preview .cabang {
  top: 42px;
  left: 290px;
  width: 100px;
  word-wrap: break-word;
}

.no-telp {
  top: 77px;
  left: 290px;
}

.pdf-content-preview .no-telp {
  top: 70px;
  left: 290px;
}

.no-sbg {
  top: 110px;
  left: 230px;
}

.pdf-content-preview .no-sbg {
  top: 106px;
  left: 230px;
}

.tgl-transaksi {
  top: 145px;
  left: 130px;
}

.pdf-content-preview .tgl-transaksi {
  top: 141px;
  left: 135px;
}

.tgl-transaksi p {
  padding: 0;
  font-size: 8px;
}

.tgl-jatuh-tempo p {
  padding: 0;
  font-size: 8px;
}

.tgl-jatuh-tempo {
  top: 160px;
  left: 130px;
}

.pdf-content-preview .tgl-jatuh-tempo {
  top: 151px;
  left: 135px;
}

.sbg-transaksi {
  font-size: 9px;
}

.data-diri {
  top: 174px;
  left: 130px;
}

.pdf-content-preview .data-diri {
  top: 171px;
  left: 135px;
}

.data-diri p {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 9px;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
  line-height: 1.5;
}

.data-diri .alamat {
  margin-top: 2px;
  width: 240px;
  word-wrap: break-word;
}

.data-diri .no-telp {
  margin-top: 5px;
}

.absolute p {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 9px;
  line-height: 1.2;
}

.qr-code {
  top: 50px;
  left: 420px;
  justify-items: center;
}

.pdf-content-preview .qr-code {
  top: 42px;
  left: 420px;
}

.pdf-content-preview .keterangan {
  top: 282px;
  left: 41px;
  width: 330px;
  word-wrap: break-word;
  text-indent: 130px;
}

.keterangan {
  top: 288px;
  left: 38px;
  width: 330px;
  word-wrap: break-word;
  text-indent: 130px;
}

.keterangan p {
  font-size: 8px;
}

.pinjaman {
  top: 338px;
  left: 133px;
}

.pinjaman .nilai-pinjaman {
  margin-top: 1px;
}

.pdf-content-preview .pinjaman {
  top: 334px;
  left: 133px;
}

.bilangan {
  top: 365px;
  left: 41px;
}

.pdf-content-preview .bilangan {
  top: 360px;
  left: 45px;
}

.tanggal {
  top: 400px;
  left: 200px;
}

.tanggal p {
  font-size: 10px !important;
  font-weight: 800;
}

.nama {
  top: 550px;
  left: 60px;
  max-width: 80px;
  word-wrap: break-word;
}

.pdf-content-preview .nama {
  top: 535px;
  left: 55px;
}

.nama p {
  font-size: 10px !important;
  font-weight: bold;
}

.qr-code-2 {
  top: 38px;
  right: 28px;
  justify-items: center;
}

.kode {
  top: 35px;
  left: 595px;
  width: 30px;
  height: 57px;
  align-content: center;
  word-wrap: break-word;
}

.pdf-content-preview .kode {
  top: 29px;
  left: 595px;
  width: 30px;
  height: 57px;
  align-content: center;
  word-wrap: break-word;
}

.kode h6{
  text-align: -webkit-center;
}

.no {
  top: 115px;
  left: 595px;
}

.no-2 {
  top: 214px;
  left: 610px;
}

.flex {
  display: flex;
}

.data-diri-2 {
  top: 250px;
  left: 682px;
}

.pdf-content-preview .data-diri-2 {
  top: 249px;
  left: 682px;
}

.data-diri-2 .no-anggota {
  margin-top: 16px !important;
}

.data-diri-2 .no-anggota-non-bpkb {
  margin-top: 8px !important;
}

.data-diri-2 .nama {
  margin-top: 4px !important;
}

.data-diri-2 .no-ktp {
  margin-top: 20px !important;
}

.data-diri-2 .no-ktp-non-bpkb {
  margin-top: 12px !important;
}

.data-diri-2 .no-telp {
  margin-top: 12px !important;
}

.data-diri-2 .alamat {
  width: 100px;
}

.data-diri-2 .alamat p {
  font-size: 8px;
}

.keterangan-2 {
  top: 438px;
  left: 580px;
  max-width: 200px;
  word-wrap: break-word;
}

.keterangan-2 p {
  font-size: 8px;
}

.uang {
  top: 510px;
  left: 675px;
}

.uang .uang-pinjaman {
  margin-top: 1px;
}

.pdf-content-preview .uang {
  top: 501px;
  left: 673px;
}

.nasabah {
  top: 665px;
  left: 650px;
  max-width: 80px;
  word-wrap: break-word;
}

.pdf-content-preview .nasabah {
  top: 648px;
  left: 650px;
}

.nasabah p {
  font-size: 10px !important;
  font-weight: bold;
}

.tgl {
  top: 545px;
  right:10px;
}

.ktp {
  width: 12vw;
  height: 250px;
  background-color: gray;
  top: 824px;
  right: 1px;
}

.ktp img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
